import { render, staticRenderFns } from "./PointMapping.vue?vue&type=template&id=bb3c513c&scoped=true"
import script from "./PointMapping.vue?vue&type=script&lang=js"
export * from "./PointMapping.vue?vue&type=script&lang=js"
import style0 from "./PointMapping.vue?vue&type=style&index=0&id=bb3c513c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3c513c",
  null
  
)

export default component.exports